module.exports = __webpack_public_path__ + "static/media/Walk-through_Login_1.94ab0595.jpg";